import {
  RESET_DASHBOARDVALUEOVERTIME_REQUESTED,
  RESET_DASHBOARDVALUEOVERTIME_COMPLETED,
} from './types';

const resetAction = () => (dispatch) => {
  dispatch({
    type: RESET_DASHBOARDVALUEOVERTIME_REQUESTED,
  });

  dispatch({
    type: RESET_DASHBOARDVALUEOVERTIME_COMPLETED,
  });
};

export default resetAction;
